import { SProductFilters } from '@/generated/graphql/types';

const filtersForBrand: { [key: string]: string[] } = {
  '1145': ['DYSON'],
};

export const generateSpecificFiltersForBrand = (
  brandId: number | null | undefined,
): SProductFilters => {
  return brandId &&
    filtersForBrand[brandId.toString()] &&
    filtersForBrand[brandId.toString()].length
    ? {
        brandNames: filtersForBrand[brandId.toString()],
      }
    : {};
};
